import { SYSTEM_MESSAGE_IDS } from 'src/app/shared/constants/systemMessages.constants'
import { IBankUserSetup } from 'src/app/shared/models/bankUserSetup.model'
import { PatternValidate } from 'src/app/shared/utils'
import * as yup from 'yup'

const phoneRegexByCountry = {
  '1': /^(\d{3}[-\s]?\d{3}[-\s]?\d{4})?$/, // USA
  '84': /^((0|\+84)\d{9,10})?$/, // Vietnam
}

function generateValidationSchema(t: any) {
  const validationSchema = yup.object().shape({
    username: yup.string().required(
      t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
        Required_Field: t('BankSetup:addNewBankUser.label.userName'),
      }),
    ),
    firstName: yup.string().required(
      t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
        Required_Field: t('BankSetup:addNewBankUser.label.firstName'),
      }),
    ),
    lastName: yup.string().required(
      t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
        Required_Field: t('BankSetup:addNewBankUser.label.lastName'),
      }),
    ),
    email: yup
      .string()
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: t('BankSetup:addNewBankUser.label.emailAddress'),
        }),
      )
      .matches(PatternValidate.emailPattern(), t('SystemMessages:' + SYSTEM_MESSAGE_IDS.INVALID_EMAIL)),
    role: yup
      .string()
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: `${t('ClientUserSetup:selectApplicableRoles.errorTitle')}`,
        }),
      ),
    primaryPhoneNumber: yup.string().when('primaryPrefix', (primaryPrefix: any, schema: any) => {
      let regex: RegExp
      let prefix = primaryPrefix[0]
      switch (prefix) {
        case '1':
          regex = phoneRegexByCountry['1']
          break
        case '84':
          regex = phoneRegexByCountry['84']
          break
        default:
          regex = phoneRegexByCountry['1']
      }

      return schema.matches(regex, {
        message: t('SystemMessages:' + SYSTEM_MESSAGE_IDS.INVALID_PHONE_NUMBER, {
          Object: t('BankSetup:addNewBankUser.label.primaryPhoneNumber'),
        }),
      })
    }),
    mobileNumber: yup.string().when('mobilePrefix', (mobilePrefix: any, schema: any) => {
      let regex: RegExp
      let prefix = mobilePrefix[0]
      switch (prefix) {
        case '1':
          regex = phoneRegexByCountry['1']
          break
        case '84':
          regex = phoneRegexByCountry['84']
          break
        default:
          regex = phoneRegexByCountry['1']
      }

      return schema.matches(regex, {
        message: t('SystemMessages:' + SYSTEM_MESSAGE_IDS.INVALID_PHONE_NUMBER, {
          Object: t('BankSetup:addNewBankUser.label.mobileNumber'),
        }),
      })
    }),
  })
  return validationSchema
}

const formatDataBeforeSubmit = (data: IBankUserSetup) => {
  return {
    ...data,
    username: data?.username.trim(),
    firstName: data?.firstName.trim(),
    lastName: data?.lastName.trim(),
    email: data?.email?.trim().toLowerCase(),
    primaryPhoneNumber: data?.primaryPhoneNumber,
    mobileNumber: data?.mobileNumber,
  }
}
function mappingDataToForm(data: any) {
  const {
    username,
    firstName,
    lastName,
    email,
    isNotReceiveOtherMail,
    primaryPrefix,
    primaryPhoneNumber,
    mobilePrefix,
    mobileNumber,
    clients,
    isAssignedAllNewClient,
    role,
    status,
  } = data

  return {
    username,
    firstName,
    lastName,
    email,
    isNotReceiveOtherMail,
    primaryPrefix,
    primaryPhoneNumber,
    mobilePrefix,
    mobileNumber,
    clients,
    isAssignedAllNewClient,
    role: role,
    status,
  }
}
function mappingDataToFormCopy(data: any) {
  const { isNotReceiveOtherMail, clients, isAssignedAllNewClient, role } = data

  return {
    isNotReceiveOtherMail,
    clients,
    isAssignedAllNewClient,
    role: role,
  }
}

export { generateValidationSchema, formatDataBeforeSubmit, mappingDataToForm, mappingDataToFormCopy }
